module.exports = __webpack_public_path__ + "img/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.77574027.webp";